export const AVGMockMark = ({ size = 20, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='#DCFAE6'
      />
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='url(#paint0_linear_1018_8501)'
        fill-opacity='0.7'
      />
      <path
        d='M29.6569 24.007C29.4234 24.031 29.1998 24.1138 29.0069 24.2475C28.8141 24.3813 28.6582 24.5617 28.5539 24.772L27.6989 26.495L25.7919 26.772C25.2719 26.844 24.8319 27.212 24.6679 27.716L24.6299 27.856C24.5299 28.321 24.6759 28.81 25.0229 29.146L26.3999 30.483L26.0739 32.375C26.0311 32.6305 26.0605 32.8928 26.1586 33.1326C26.2568 33.3723 26.4198 33.5799 26.6294 33.7321C26.8391 33.8843 27.087 33.975 27.3453 33.9941C27.6037 34.0131 27.8622 33.9598 28.0919 33.84L29.7999 32.945L31.5079 33.841C31.7371 33.9617 31.9955 34.0158 32.2539 33.9972C32.5123 33.9787 32.7603 33.8882 32.9699 33.736L33.0819 33.646C33.2573 33.4888 33.3899 33.2896 33.4672 33.0671C33.5445 32.8446 33.564 32.6061 33.5239 32.374L33.1989 30.483L34.5789 29.144C34.9589 28.773 35.0949 28.22 34.9309 27.717L34.8799 27.583C34.7841 27.3683 34.6355 27.1813 34.4478 27.0396C34.2602 26.898 34.0397 26.8062 33.8069 26.773L31.8999 26.495L31.0469 24.773C30.9315 24.5409 30.7537 24.3456 30.5334 24.209C30.3131 24.0725 30.0591 24.0001 29.7999 24L29.6569 24.007Z'
        fill='#17B26A'
      />
      <path
        d='M29.6569 24.007C29.4234 24.031 29.1998 24.1138 29.0069 24.2475C28.8141 24.3813 28.6582 24.5617 28.5539 24.772L27.6989 26.495L25.7919 26.772C25.2719 26.844 24.8319 27.212 24.6679 27.716L24.6299 27.856C24.5299 28.321 24.6759 28.81 25.0229 29.146L26.3999 30.483L26.0739 32.375C26.0311 32.6305 26.0605 32.8928 26.1586 33.1326C26.2568 33.3723 26.4198 33.5799 26.6294 33.7321C26.8391 33.8843 27.087 33.975 27.3453 33.9941C27.6037 34.0131 27.8622 33.9598 28.0919 33.84L29.7999 32.945L31.5079 33.841C31.7371 33.9617 31.9955 34.0158 32.2539 33.9972C32.5123 33.9787 32.7603 33.8882 32.9699 33.736L33.0819 33.646C33.2573 33.4888 33.3899 33.2896 33.4672 33.0671C33.5445 32.8446 33.564 32.6061 33.5239 32.374L33.1989 30.483L34.5789 29.144C34.9589 28.773 35.0949 28.22 34.9309 27.717L34.8799 27.583C34.7841 27.3683 34.6355 27.1813 34.4478 27.0396C34.2602 26.898 34.0397 26.8062 33.8069 26.773L31.8999 26.495L31.0469 24.773C30.9315 24.5409 30.7537 24.3456 30.5334 24.209C30.3131 24.0725 30.0591 24.0001 29.7999 24L29.6569 24.007Z'
        fill='url(#paint1_linear_1018_8501)'
        fill-opacity='0.35'
      />
      <path
        d='M18.0569 24.007C17.8234 24.031 17.5998 24.1138 17.4069 24.2475C17.2141 24.3813 17.0582 24.5617 16.9539 24.772L16.0989 26.495L14.1919 26.772C13.6719 26.844 13.2319 27.212 13.0679 27.716L13.0299 27.856C12.9299 28.321 13.0759 28.81 13.4229 29.146L14.7999 30.483L14.4739 32.375C14.4312 32.6305 14.4605 32.8928 14.5586 33.1326C14.6568 33.3723 14.8198 33.5799 15.0294 33.7321C15.2391 33.8843 15.487 33.975 15.7453 33.9941C16.0037 34.0131 16.2622 33.9598 16.4919 33.84L18.1999 32.945L19.9079 33.841C20.1371 33.9617 20.3955 34.0158 20.6539 33.9972C20.9123 33.9787 21.1603 33.8882 21.3699 33.736L21.4819 33.646C21.6573 33.4888 21.7899 33.2896 21.8672 33.0671C21.9445 32.8446 21.964 32.6061 21.9239 32.374L21.5999 30.483L22.9799 29.144C23.3599 28.773 23.4959 28.22 23.3319 27.717L23.2809 27.583C23.1852 27.3683 23.0365 27.1813 22.8488 27.0396C22.6612 26.898 22.4407 26.8062 22.2079 26.773L20.2999 26.494L19.4469 24.772C19.3314 24.5401 19.1535 24.345 18.9332 24.2086C18.7129 24.0722 18.459 24 18.1999 24L18.0569 24.007Z'
        fill='#17B26A'
      />
      <path
        d='M18.0569 24.007C17.8234 24.031 17.5998 24.1138 17.4069 24.2475C17.2141 24.3813 17.0582 24.5617 16.9539 24.772L16.0989 26.495L14.1919 26.772C13.6719 26.844 13.2319 27.212 13.0679 27.716L13.0299 27.856C12.9299 28.321 13.0759 28.81 13.4229 29.146L14.7999 30.483L14.4739 32.375C14.4312 32.6305 14.4605 32.8928 14.5586 33.1326C14.6568 33.3723 14.8198 33.5799 15.0294 33.7321C15.2391 33.8843 15.487 33.975 15.7453 33.9941C16.0037 34.0131 16.2622 33.9598 16.4919 33.84L18.1999 32.945L19.9079 33.841C20.1371 33.9617 20.3955 34.0158 20.6539 33.9972C20.9123 33.9787 21.1603 33.8882 21.3699 33.736L21.4819 33.646C21.6573 33.4888 21.7899 33.2896 21.8672 33.0671C21.9445 32.8446 21.964 32.6061 21.9239 32.374L21.5999 30.483L22.9799 29.144C23.3599 28.773 23.4959 28.22 23.3319 27.717L23.2809 27.583C23.1852 27.3683 23.0365 27.1813 22.8488 27.0396C22.6612 26.898 22.4407 26.8062 22.2079 26.773L20.2999 26.494L19.4469 24.772C19.3314 24.5401 19.1535 24.345 18.9332 24.2086C18.7129 24.0722 18.459 24 18.1999 24L18.0569 24.007Z'
        fill='url(#paint2_linear_1018_8501)'
        fill-opacity='0.35'
      />
      <path
        d='M23.8569 14.007C23.6234 14.031 23.3998 14.1138 23.2069 14.2475C23.0141 14.3813 22.8582 14.5617 22.7539 14.772L21.8989 16.495L19.9919 16.772C19.4719 16.844 19.0319 17.212 18.8679 17.716L18.8299 17.856C18.7299 18.321 18.8759 18.81 19.2229 19.146L20.5999 20.483L20.2739 22.375C20.2311 22.6305 20.2605 22.8928 20.3586 23.1326C20.4568 23.3723 20.6198 23.5799 20.8294 23.7321C21.0391 23.8843 21.287 23.975 21.5453 23.9941C21.8037 24.0131 22.0622 23.9598 22.2919 23.84L23.9999 22.946L25.7089 23.842C25.9381 23.9627 26.1965 24.0168 26.4549 23.9982C26.7132 23.9797 26.9613 23.8892 27.1709 23.737L27.2829 23.647C27.4583 23.4898 27.5909 23.2906 27.6682 23.0681C27.7455 22.8456 27.765 22.6071 27.7249 22.375L27.3999 20.483L28.7799 19.144C29.1599 18.773 29.2959 18.22 29.1319 17.717L29.0809 17.583C28.9851 17.3683 28.8365 17.1813 28.6488 17.0396C28.4612 16.898 28.2406 16.8062 28.0079 16.773L26.0999 16.494L25.2469 14.772C25.1314 14.5401 24.9535 14.345 24.7332 14.2086C24.5129 14.0722 24.259 14 23.9999 14L23.8569 14.007Z'
        fill='#17B26A'
      />
      <path
        d='M23.8569 14.007C23.6234 14.031 23.3998 14.1138 23.2069 14.2475C23.0141 14.3813 22.8582 14.5617 22.7539 14.772L21.8989 16.495L19.9919 16.772C19.4719 16.844 19.0319 17.212 18.8679 17.716L18.8299 17.856C18.7299 18.321 18.8759 18.81 19.2229 19.146L20.5999 20.483L20.2739 22.375C20.2311 22.6305 20.2605 22.8928 20.3586 23.1326C20.4568 23.3723 20.6198 23.5799 20.8294 23.7321C21.0391 23.8843 21.287 23.975 21.5453 23.9941C21.8037 24.0131 22.0622 23.9598 22.2919 23.84L23.9999 22.946L25.7089 23.842C25.9381 23.9627 26.1965 24.0168 26.4549 23.9982C26.7132 23.9797 26.9613 23.8892 27.1709 23.737L27.2829 23.647C27.4583 23.4898 27.5909 23.2906 27.6682 23.0681C27.7455 22.8456 27.765 22.6071 27.7249 22.375L27.3999 20.483L28.7799 19.144C29.1599 18.773 29.2959 18.22 29.1319 17.717L29.0809 17.583C28.9851 17.3683 28.8365 17.1813 28.6488 17.0396C28.4612 16.898 28.2406 16.8062 28.0079 16.773L26.0999 16.494L25.2469 14.772C25.1314 14.5401 24.9535 14.345 24.7332 14.2086C24.5129 14.0722 24.259 14 23.9999 14L23.8569 14.007Z'
        fill='url(#paint3_linear_1018_8501)'
        fill-opacity='0.35'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1018_8501'
          x1='24'
          y1='48'
          x2='24'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1018_8501'
          x1='23.9992'
          y1='14'
          x2='23.9992'
          y2='34.0008'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1018_8501'
          x1='23.9992'
          y1='14'
          x2='23.9992'
          y2='34.0008'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1018_8501'
          x1='23.9992'
          y1='14'
          x2='23.9992'
          y2='34.0008'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
      </defs>
    </svg>
  )
}

const AVGMark = ({ size = 20, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='#DC9703'
        fill-opacity='0.15'
      />
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='url(#paint0_linear_1018_8495)'
        fill-opacity='0.7'
      />
      <path
        d='M20.2428 19.34L13.8628 20.265L13.7498 20.288C13.5787 20.3334 13.4228 20.4234 13.2979 20.5488C13.173 20.6742 13.0836 20.8305 13.0388 21.0017C12.9941 21.1729 12.9956 21.353 13.0432 21.5235C13.0908 21.6939 13.1828 21.8487 13.3098 21.972L17.9318 26.471L16.8418 32.826L16.8288 32.936C16.8183 33.1129 16.855 33.2894 16.9352 33.4475C17.0154 33.6055 17.1361 33.7395 17.2851 33.8355C17.4341 33.9315 17.6059 33.9863 17.7829 33.9941C17.96 34.0019 18.1359 33.9625 18.2928 33.88L23.9988 30.88L29.6918 33.88L29.7918 33.926C29.9568 33.991 30.1362 34.0109 30.3115 33.9837C30.4868 33.9566 30.6517 33.8832 30.7894 33.7712C30.927 33.6593 31.0323 33.5127 31.0946 33.3466C31.1569 33.1805 31.1738 33.0008 31.1438 32.826L30.0528 26.471L34.6768 21.971L34.7548 21.886C34.8662 21.7488 34.9392 21.5844 34.9665 21.4098C34.9937 21.2351 34.9742 21.0564 34.9099 20.8917C34.8455 20.7271 34.7387 20.5824 34.6003 20.4725C34.4618 20.3626 34.2967 20.2913 34.1218 20.266L27.7418 19.34L24.8898 13.56C24.8072 13.3925 24.6795 13.2515 24.521 13.1529C24.3624 13.0543 24.1795 13.002 23.9928 13.002C23.8061 13.002 23.6231 13.0543 23.4646 13.1529C23.306 13.2515 23.1783 13.3925 23.0958 13.56L20.2428 19.34Z'
        fill='white'
      />
      <path
        d='M20.2428 19.34L13.8628 20.265L13.7498 20.288C13.5787 20.3334 13.4228 20.4234 13.2979 20.5488C13.173 20.6742 13.0836 20.8305 13.0388 21.0017C12.9941 21.1729 12.9956 21.353 13.0432 21.5235C13.0908 21.6939 13.1828 21.8487 13.3098 21.972L17.9318 26.471L16.8418 32.826L16.8288 32.936C16.8183 33.1129 16.855 33.2894 16.9352 33.4475C17.0154 33.6055 17.1361 33.7395 17.2851 33.8355C17.4341 33.9315 17.6059 33.9863 17.7829 33.9941C17.96 34.0019 18.1359 33.9625 18.2928 33.88L23.9988 30.88L29.6918 33.88L29.7918 33.926C29.9568 33.991 30.1362 34.0109 30.3115 33.9837C30.4868 33.9566 30.6517 33.8832 30.7894 33.7712C30.927 33.6593 31.0323 33.5127 31.0946 33.3466C31.1569 33.1805 31.1738 33.0008 31.1438 32.826L30.0528 26.471L34.6768 21.971L34.7548 21.886C34.8662 21.7488 34.9392 21.5844 34.9665 21.4098C34.9937 21.2351 34.9742 21.0564 34.9099 20.8917C34.8455 20.7271 34.7387 20.5824 34.6003 20.4725C34.4618 20.3626 34.2967 20.2913 34.1218 20.266L27.7418 19.34L24.8898 13.56C24.8072 13.3925 24.6795 13.2515 24.521 13.1529C24.3624 13.0543 24.1795 13.002 23.9928 13.002C23.8061 13.002 23.6231 13.0543 23.4646 13.1529C23.306 13.2515 23.1783 13.3925 23.0958 13.56L20.2428 19.34Z'
        fill='#DC9703'
      />
      <path
        d='M20.2428 19.34L13.8628 20.265L13.7498 20.288C13.5787 20.3334 13.4228 20.4234 13.2979 20.5488C13.173 20.6742 13.0836 20.8305 13.0388 21.0017C12.9941 21.1729 12.9956 21.353 13.0432 21.5235C13.0908 21.6939 13.1828 21.8487 13.3098 21.972L17.9318 26.471L16.8418 32.826L16.8288 32.936C16.8183 33.1129 16.855 33.2894 16.9352 33.4475C17.0154 33.6055 17.1361 33.7395 17.2851 33.8355C17.4341 33.9315 17.6059 33.9863 17.7829 33.9941C17.96 34.0019 18.1359 33.9625 18.2928 33.88L23.9988 30.88L29.6918 33.88L29.7918 33.926C29.9568 33.991 30.1362 34.0109 30.3115 33.9837C30.4868 33.9566 30.6517 33.8832 30.7894 33.7712C30.927 33.6593 31.0323 33.5127 31.0946 33.3466C31.1569 33.1805 31.1738 33.0008 31.1438 32.826L30.0528 26.471L34.6768 21.971L34.7548 21.886C34.8662 21.7488 34.9392 21.5844 34.9665 21.4098C34.9937 21.2351 34.9742 21.0564 34.9099 20.8917C34.8455 20.7271 34.7387 20.5824 34.6003 20.4725C34.4618 20.3626 34.2967 20.2913 34.1218 20.266L27.7418 19.34L24.8898 13.56C24.8072 13.3925 24.6795 13.2515 24.521 13.1529C24.3624 13.0543 24.1795 13.002 23.9928 13.002C23.8061 13.002 23.6231 13.0543 23.4646 13.1529C23.306 13.2515 23.1783 13.3925 23.0958 13.56L20.2428 19.34Z'
        fill='url(#paint1_linear_1018_8495)'
        fill-opacity='0.35'
      />
      <path
        d='M20.2428 19.34L13.8628 20.265L13.7498 20.288C13.5787 20.3334 13.4228 20.4234 13.2979 20.5488C13.173 20.6742 13.0836 20.8305 13.0388 21.0017C12.9941 21.1729 12.9956 21.353 13.0432 21.5235C13.0908 21.6939 13.1828 21.8487 13.3098 21.972L17.9318 26.471L16.8418 32.826L16.8288 32.936C16.8183 33.1129 16.855 33.2894 16.9352 33.4475C17.0154 33.6055 17.1361 33.7395 17.2851 33.8355C17.4341 33.9315 17.6059 33.9863 17.7829 33.9941C17.96 34.0019 18.1359 33.9625 18.2928 33.88L23.9988 30.88L29.6918 33.88L29.7918 33.926C29.9568 33.991 30.1362 34.0109 30.3115 33.9837C30.4868 33.9566 30.6517 33.8832 30.7894 33.7712C30.927 33.6593 31.0323 33.5127 31.0946 33.3466C31.1569 33.1805 31.1738 33.0008 31.1438 32.826L30.0528 26.471L34.6768 21.971L34.7548 21.886C34.8662 21.7488 34.9392 21.5844 34.9665 21.4098C34.9937 21.2351 34.9742 21.0564 34.9099 20.8917C34.8455 20.7271 34.7387 20.5824 34.6003 20.4725C34.4618 20.3626 34.2967 20.2913 34.1218 20.266L27.7418 19.34L24.8898 13.56C24.8072 13.3925 24.6795 13.2515 24.521 13.1529C24.3624 13.0543 24.1795 13.002 23.9928 13.002C23.8061 13.002 23.6231 13.0543 23.4646 13.1529C23.306 13.2515 23.1783 13.3925 23.0958 13.56L20.2428 19.34Z'
        stroke='white'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M20.2428 19.34L13.8628 20.265L13.7498 20.288C13.5787 20.3334 13.4228 20.4234 13.2979 20.5488C13.173 20.6742 13.0836 20.8305 13.0388 21.0017C12.9941 21.1729 12.9956 21.353 13.0432 21.5235C13.0908 21.6939 13.1828 21.8487 13.3098 21.972L17.9318 26.471L16.8418 32.826L16.8288 32.936C16.8183 33.1129 16.855 33.2894 16.9352 33.4475C17.0154 33.6055 17.1361 33.7395 17.2851 33.8355C17.4341 33.9315 17.6059 33.9863 17.7829 33.9941C17.96 34.0019 18.1359 33.9625 18.2928 33.88L23.9988 30.88L29.6918 33.88L29.7918 33.926C29.9568 33.991 30.1362 34.0109 30.3115 33.9837C30.4868 33.9566 30.6517 33.8832 30.7894 33.7712C30.927 33.6593 31.0323 33.5127 31.0946 33.3466C31.1569 33.1805 31.1738 33.0008 31.1438 32.826L30.0528 26.471L34.6768 21.971L34.7548 21.886C34.8662 21.7488 34.9392 21.5844 34.9665 21.4098C34.9937 21.2351 34.9742 21.0564 34.9099 20.8917C34.8455 20.7271 34.7387 20.5824 34.6003 20.4725C34.4618 20.3626 34.2967 20.2913 34.1218 20.266L27.7418 19.34L24.8898 13.56C24.8072 13.3925 24.6795 13.2515 24.521 13.1529C24.3624 13.0543 24.1795 13.002 23.9928 13.002C23.8061 13.002 23.6231 13.0543 23.4646 13.1529C23.306 13.2515 23.1783 13.3925 23.0958 13.56L20.2428 19.34Z'
        stroke='#DC9703'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M20.2428 19.34L13.8628 20.265L13.7498 20.288C13.5787 20.3334 13.4228 20.4234 13.2979 20.5488C13.173 20.6742 13.0836 20.8305 13.0388 21.0017C12.9941 21.1729 12.9956 21.353 13.0432 21.5235C13.0908 21.6939 13.1828 21.8487 13.3098 21.972L17.9318 26.471L16.8418 32.826L16.8288 32.936C16.8183 33.1129 16.855 33.2894 16.9352 33.4475C17.0154 33.6055 17.1361 33.7395 17.2851 33.8355C17.4341 33.9315 17.6059 33.9863 17.7829 33.9941C17.96 34.0019 18.1359 33.9625 18.2928 33.88L23.9988 30.88L29.6918 33.88L29.7918 33.926C29.9568 33.991 30.1362 34.0109 30.3115 33.9837C30.4868 33.9566 30.6517 33.8832 30.7894 33.7712C30.927 33.6593 31.0323 33.5127 31.0946 33.3466C31.1569 33.1805 31.1738 33.0008 31.1438 32.826L30.0528 26.471L34.6768 21.971L34.7548 21.886C34.8662 21.7488 34.9392 21.5844 34.9665 21.4098C34.9937 21.2351 34.9742 21.0564 34.9099 20.8917C34.8455 20.7271 34.7387 20.5824 34.6003 20.4725C34.4618 20.3626 34.2967 20.2913 34.1218 20.266L27.7418 19.34L24.8898 13.56C24.8072 13.3925 24.6795 13.2515 24.521 13.1529C24.3624 13.0543 24.1795 13.002 23.9928 13.002C23.8061 13.002 23.6231 13.0543 23.4646 13.1529C23.306 13.2515 23.1783 13.3925 23.0958 13.56L20.2428 19.34Z'
        stroke='url(#paint2_linear_1018_8495)'
        stroke-opacity='0.35'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1018_8495'
          x1='24'
          y1='48'
          x2='24'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1018_8495'
          x1='23.9924'
          y1='13.002'
          x2='23.9924'
          y2='33.9956'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1018_8495'
          x1='23.9924'
          y1='13.002'
          x2='23.9924'
          y2='33.9956'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default AVGMark

export const ParticipantsIcon = ({ size = 20, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='#0057B8'
        fill-opacity='0.15'
      />
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='url(#paint0_linear_3184_66911)'
        fill-opacity='0.7'
      />
      <path
        d='M20.4121 27.6113C20.5171 27.6156 20.603 27.6413 20.7168 27.6758C21.4563 27.8998 22.567 29.5328 23.2676 30.042C23.6816 30.3428 24.2216 30.3583 24.6436 30.0674C25.3689 29.5664 26.3961 27.992 27.1436 27.7061C27.6475 27.5138 28.1173 27.7273 28.6055 27.9014C30.7522 28.6658 33.129 30.4059 33.5352 32.8086C33.7944 34.3446 33.0649 35.6761 31.4922 35.9424L16.5049 35.9453C13.3834 35.2901 14.1267 31.9072 15.8301 30.0986C16.6923 29.1836 19.06 27.7267 20.2979 27.6152L20.4121 27.6113ZM22.7744 12.2979C23.5428 12.0379 24.3999 12.0374 25.1699 12.2979L33.5322 16.0166C33.8248 16.19 33.9543 16.4389 33.876 16.7822C33.8297 16.9851 33.6038 17.0401 33.6035 17.2451L33.5811 23.4072C33.4291 24.055 32.7685 24.3655 32.1895 24.0078C32.0611 23.9284 31.8037 23.6279 31.8037 23.4893V17.958L28.7891 19.3184C28.7071 20.9931 28.9967 22.3981 28.1094 23.9102C25.8811 27.7052 20.0156 26.6759 19.2568 22.3945C19.0761 21.3726 19.2825 20.302 19.1328 19.2852L14.3438 17.1299C13.9274 16.8552 13.9498 16.2881 14.3809 16.043L22.7744 12.2979Z'
        fill='#0057B8'
      />
      <path
        d='M20.4121 27.6113C20.5171 27.6156 20.603 27.6413 20.7168 27.6758C21.4563 27.8998 22.567 29.5328 23.2676 30.042C23.6816 30.3428 24.2216 30.3583 24.6436 30.0674C25.3689 29.5664 26.3961 27.992 27.1436 27.7061C27.6475 27.5138 28.1173 27.7273 28.6055 27.9014C30.7522 28.6658 33.129 30.4059 33.5352 32.8086C33.7944 34.3446 33.0649 35.6761 31.4922 35.9424L16.5049 35.9453C13.3834 35.2901 14.1267 31.9072 15.8301 30.0986C16.6923 29.1836 19.06 27.7267 20.2979 27.6152L20.4121 27.6113ZM22.7744 12.2979C23.5428 12.0379 24.3999 12.0374 25.1699 12.2979L33.5322 16.0166C33.8248 16.19 33.9543 16.4389 33.876 16.7822C33.8297 16.9851 33.6038 17.0401 33.6035 17.2451L33.5811 23.4072C33.4291 24.055 32.7685 24.3655 32.1895 24.0078C32.0611 23.9284 31.8037 23.6279 31.8037 23.4893V17.958L28.7891 19.3184C28.7071 20.9931 28.9967 22.3981 28.1094 23.9102C25.8811 27.7052 20.0156 26.6759 19.2568 22.3945C19.0761 21.3726 19.2825 20.302 19.1328 19.2852L14.3438 17.1299C13.9274 16.8552 13.9498 16.2881 14.3809 16.043L22.7744 12.2979Z'
        fill='url(#paint1_linear_3184_66911)'
        fill-opacity='0.35'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3184_66911'
          x1='24'
          y1='48'
          x2='24'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3184_66911'
          x1='23.9711'
          y1='12.1025'
          x2='23.9711'
          y2='35.9451'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const TestAttemps = ({ size = 20, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='#B42318'
        fill-opacity='0.11'
      />
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='url(#paint0_linear_3184_66922)'
        fill-opacity='0.7'
      />
      <path
        d='M18.9791 15.0735C19.8642 14.9227 20.7718 14.9725 21.6351 15.2191C22.4984 15.4657 23.2953 15.9029 23.9671 16.4985L24.0041 16.5315L24.0381 16.5015C24.6793 15.9388 25.4331 15.5193 26.2493 15.271C27.0655 15.0227 27.9252 14.9513 28.7711 15.0615L29.0171 15.0975C30.0834 15.2816 31.0801 15.7507 31.9016 16.455C32.7231 17.1593 33.3388 18.0727 33.6836 19.0984C34.0283 20.124 34.0893 21.2239 33.86 22.2814C33.6307 23.3389 33.1197 24.3147 32.3811 25.1055L32.2011 25.2905L32.1531 25.3315L24.7031 32.7105C24.5312 32.8807 24.3034 32.9828 24.062 32.9978C23.8206 33.0129 23.5819 32.94 23.3901 32.7925L23.2961 32.7105L15.8031 25.2885C15.0093 24.5162 14.4448 23.5392 14.1721 22.4658C13.8993 21.3924 13.929 20.2644 14.2578 19.2068C14.5867 18.1493 15.2018 17.2033 16.0351 16.4738C16.8684 15.7443 17.8874 15.2596 18.9791 15.0735Z'
        fill='#1D2939'
      />
      <path
        d='M18.9791 15.0735C19.8642 14.9227 20.7718 14.9725 21.6351 15.2191C22.4984 15.4657 23.2953 15.9029 23.9671 16.4985L24.0041 16.5315L24.0381 16.5015C24.6793 15.9388 25.4331 15.5193 26.2493 15.271C27.0655 15.0227 27.9252 14.9513 28.7711 15.0615L29.0171 15.0975C30.0834 15.2816 31.0801 15.7507 31.9016 16.455C32.7231 17.1593 33.3388 18.0727 33.6836 19.0984C34.0283 20.124 34.0893 21.2239 33.86 22.2814C33.6307 23.3389 33.1197 24.3147 32.3811 25.1055L32.2011 25.2905L32.1531 25.3315L24.7031 32.7105C24.5312 32.8807 24.3034 32.9828 24.062 32.9978C23.8206 33.0129 23.5819 32.94 23.3901 32.7925L23.2961 32.7105L15.8031 25.2885C15.0093 24.5162 14.4448 23.5392 14.1721 22.4658C13.8993 21.3924 13.929 20.2644 14.2578 19.2068C14.5867 18.1493 15.2018 17.2033 16.0351 16.4738C16.8684 15.7443 17.8874 15.2596 18.9791 15.0735Z'
        fill='#B42318'
      />
      <path
        d='M18.9791 15.0735C19.8642 14.9227 20.7718 14.9725 21.6351 15.2191C22.4984 15.4657 23.2953 15.9029 23.9671 16.4985L24.0041 16.5315L24.0381 16.5015C24.6793 15.9388 25.4331 15.5193 26.2493 15.271C27.0655 15.0227 27.9252 14.9513 28.7711 15.0615L29.0171 15.0975C30.0834 15.2816 31.0801 15.7507 31.9016 16.455C32.7231 17.1593 33.3388 18.0727 33.6836 19.0984C34.0283 20.124 34.0893 21.2239 33.86 22.2814C33.6307 23.3389 33.1197 24.3147 32.3811 25.1055L32.2011 25.2905L32.1531 25.3315L24.7031 32.7105C24.5312 32.8807 24.3034 32.9828 24.062 32.9978C23.8206 33.0129 23.5819 32.94 23.3901 32.7925L23.2961 32.7105L15.8031 25.2885C15.0093 24.5162 14.4448 23.5392 14.1721 22.4658C13.8993 21.3924 13.929 20.2644 14.2578 19.2068C14.5867 18.1493 15.2018 17.2033 16.0351 16.4738C16.8684 15.7443 17.8874 15.2596 18.9791 15.0735Z'
        fill='url(#paint1_linear_3184_66922)'
        fill-opacity='0.35'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3184_66922'
          x1='24'
          y1='48'
          x2='24'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3184_66922'
          x1='23.9918'
          y1='14.9883'
          x2='23.9918'
          y2='32.9998'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' stop-opacity='0' />
          <stop offset='1' stop-color='white' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const TestAVGAIMarks = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='#DC9703'
      fill-opacity='0.15'
    />
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='url(#paint0_linear_5451_48632)'
      fill-opacity='0.7'
    />
    <g filter='url(#filter0_d_5451_48632)'>
      <path
        d='M28.3333 29.4997C28.908 29.4997 29.4591 29.7279 29.8654 30.1343C30.2717 30.5406 30.5 31.0917 30.5 31.6663C30.5 31.0917 30.7283 30.5406 31.1346 30.1343C31.5409 29.7279 32.092 29.4997 32.6667 29.4997C32.092 29.4997 31.5409 29.2714 31.1346 28.8651C30.7283 28.4587 30.5 27.9076 30.5 27.333C30.5 27.9076 30.2717 28.4587 29.8654 28.8651C29.4591 29.2714 28.908 29.4997 28.3333 29.4997ZM28.3333 16.4997C28.908 16.4997 29.4591 16.7279 29.8654 17.1343C30.2717 17.5406 30.5 18.0917 30.5 18.6663C30.5 18.0917 30.7283 17.5406 31.1346 17.1343C31.5409 16.7279 32.092 16.4997 32.6667 16.4997C32.092 16.4997 31.5409 16.2714 31.1346 15.8651C30.7283 15.4587 30.5 14.9076 30.5 14.333C30.5 14.9076 30.2717 15.4587 29.8654 15.8651C29.4591 16.2714 28.908 16.4997 28.3333 16.4997ZM20.75 29.4997C20.75 27.7758 21.4348 26.1225 22.6538 24.9035C23.8728 23.6845 25.5261 22.9997 27.25 22.9997C25.5261 22.9997 23.8728 22.3149 22.6538 21.0959C21.4348 19.8769 20.75 18.2236 20.75 16.4997C20.75 18.2236 20.0652 19.8769 18.8462 21.0959C17.6272 22.3149 15.9739 22.9997 14.25 22.9997C15.9739 22.9997 17.6272 23.6845 18.8462 24.9035C20.0652 26.1225 20.75 27.7758 20.75 29.4997Z'
        fill='black'
        stroke='black'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_5451_48632'
        x='7'
        y='9'
        width='34'
        height='34'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
        <feBlend
          mode='overlay'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_5451_48632'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_5451_48632'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_5451_48632'
        x1='24'
        y1='48'
        x2='24'
        y2='0'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='white' stop-opacity='0' />
        <stop offset='1' stop-color='white' />
      </linearGradient>
    </defs>
  </svg>
)

export const TestMockExamMarks = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='#DCFAE6'
    />
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='url(#paint0_linear_5451_48633)'
      fill-opacity='0.7'
    />
    <path
      d='M20.7168 22.0322C21.378 21.9528 21.836 22.6101 21.626 23.2422L19.6104 29.3096C19.5308 29.5997 19.5824 29.9116 19.7402 30.165C19.7679 30.2094 19.8028 30.2491 19.8398 30.2861L21.7783 32.2246C22.4081 32.8546 21.9621 33.9316 21.0713 33.9316H13.8564C13.5899 33.9315 13.2801 33.5848 13.1035 33.3047C13.028 33.1848 13 33.0431 13 32.9014V30.0244C13 29.9583 13.0065 29.8919 13.0195 29.8271L13.3242 28.3105C14.2767 24.958 17.2679 22.4483 20.7168 22.0322ZM27.2139 22.0322C30.8108 22.4661 33.9245 25.1839 34.7178 28.7441C34.9446 29.7635 35.0855 32.0601 34.915 33.0664C34.8592 33.3937 34.4058 33.9316 34.0752 33.9316H26.8604C25.9694 33.9316 25.5233 32.8546 26.1533 32.2246L28.0918 30.2861C28.1287 30.2492 28.1628 30.2094 28.1904 30.165C28.3483 29.9116 28.4008 29.5998 28.3213 29.3096L26.3047 23.2412C26.0947 22.6092 26.5527 21.9526 27.2139 22.0322ZM24.5 22C25.0523 22 25.5 22.4477 25.5 23V24C25.5 24.5243 25.0964 24.9529 24.583 24.9951L25.8027 28.6855C25.923 29.0493 25.8247 29.4499 25.5498 29.7168L24.6465 30.5938C24.2551 30.9734 23.6318 30.9694 23.2451 30.585L22.374 29.7188C22.1045 29.4507 22.0103 29.0529 22.1309 28.6924L23.3691 24.9902C22.8788 24.9261 22.5 24.5079 22.5 24V23C22.5 22.4477 22.9477 22 23.5 22H24.5ZM23.3496 10.0234C23.6624 9.99208 24.2702 9.99207 24.583 10.0234C26.7555 10.2416 28.7209 11.9745 29.2627 14.0459C30.572 19.0529 24.8294 22.8953 20.6543 19.793C16.717 16.8666 18.5082 10.5089 23.3496 10.0234Z'
      fill='#52C690'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5451_48633'
        x1='24'
        y1='48'
        x2='24'
        y2='0'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='white' stop-opacity='0' />
        <stop offset='1' stop-color='white' />
      </linearGradient>
    </defs>
  </svg>
)

export const AiMarking = ({ size = 48, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='#0057B8'
    />
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='url(#paint0_linear_3017_48606)'
      fill-opacity='0.7'
    />
    <g filter='url(#filter0_d_3017_48606)'>
      <path
        d='M28 30C28.5304 30 29.0391 30.2107 29.4142 30.5858C29.7893 30.9609 30 31.4696 30 32C30 31.4696 30.2107 30.9609 30.5858 30.5858C30.9609 30.2107 31.4696 30 32 30C31.4696 30 30.9609 29.7893 30.5858 29.4142C30.2107 29.0391 30 28.5304 30 28C30 28.5304 29.7893 29.0391 29.4142 29.4142C29.0391 29.7893 28.5304 30 28 30ZM28 18C28.5304 18 29.0391 18.2107 29.4142 18.5858C29.7893 18.9609 30 19.4696 30 20C30 19.4696 30.2107 18.9609 30.5858 18.5858C30.9609 18.2107 31.4696 18 32 18C31.4696 18 30.9609 17.7893 30.5858 17.4142C30.2107 17.0391 30 16.5304 30 16C30 16.5304 29.7893 17.0391 29.4142 17.4142C29.0391 17.7893 28.5304 18 28 18ZM21 30C21 28.4087 21.6321 26.8826 22.7574 25.7574C23.8826 24.6321 25.4087 24 27 24C25.4087 24 23.8826 23.3679 22.7574 22.2426C21.6321 21.1174 21 19.5913 21 18C21 19.5913 20.3679 21.1174 19.2426 22.2426C18.1174 23.3679 16.5913 24 15 24C16.5913 24 18.1174 24.6321 19.2426 25.7574C20.3679 26.8826 21 28.4087 21 30Z'
        fill='white'
        stroke='white'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_3017_48606'
        x='8'
        y='11'
        width='32'
        height='32'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
        <feBlend
          mode='overlay'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3017_48606'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_3017_48606'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_3017_48606'
        x1='24'
        y1='48'
        x2='24'
        y2='0'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='white' stop-opacity='0.2' />
        <stop offset='1' stop-color='white' />
      </linearGradient>
    </defs>
  </svg>
)

export const TutorMarking = ({ size = 48, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...rest}
  >
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='#0057B8'
    />
    <path
      d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
      fill='url(#paint0_linear_3017_48613)'
      fill-opacity='0.7'
    />
    <g filter='url(#filter0_d_3017_48613)'>
      <path
        d='M20.7168 24.0326C21.378 23.9532 21.836 24.6104 21.626 25.2426L19.6104 31.3099C19.5308 31.6001 19.5824 31.912 19.7402 32.1654C19.7679 32.2098 19.8028 32.2495 19.8398 32.2865L21.7783 34.225C22.4081 34.8549 21.9621 35.932 21.0713 35.932H13.8564C13.5899 35.9319 13.2801 35.5852 13.1035 35.3051C13.028 35.1852 13 35.0434 13 34.9017V32.0248C13 31.9587 13.0065 31.8923 13.0195 31.8275L13.3242 30.3109C14.2767 26.9584 17.2679 24.4487 20.7168 24.0326ZM27.2139 24.0326C30.8108 24.4665 33.9245 27.1843 34.7178 30.7445C34.9446 31.7638 35.0855 34.0604 34.915 35.0668C34.8592 35.3941 34.4058 35.932 34.0752 35.932H26.8604C25.9694 35.932 25.5233 34.8549 26.1533 34.225L28.0918 32.2865C28.1287 32.2496 28.1628 32.2097 28.1904 32.1654C28.3483 31.912 28.4008 31.6001 28.3213 31.3099L26.3047 25.2416C26.0947 24.6096 26.5527 23.953 27.2139 24.0326ZM24.5 24.0004C25.0523 24.0004 25.5 24.4481 25.5 25.0004V26.0004C25.4998 26.5252 25.0953 26.9542 24.5811 26.9955L25.8018 30.6859C25.922 31.0497 25.8237 31.4502 25.5488 31.7172L24.6455 32.5941C24.2541 32.9737 23.6308 32.9698 23.2441 32.5853L22.373 31.7191C22.1035 31.4511 22.0093 31.0532 22.1299 30.6927L23.3691 26.9896C22.8789 26.9254 22.5002 26.508 22.5 26.0004V25.0004C22.5 24.4481 22.9477 24.0004 23.5 24.0004H24.5ZM23.3486 12.0238C23.6614 11.9924 24.2691 11.9925 24.582 12.0238C26.7545 12.242 28.72 13.9749 29.2617 16.0463C30.5712 21.0533 24.8284 24.8959 20.6533 21.7933C16.7161 18.867 18.5075 12.5095 23.3486 12.0238Z'
        fill='white'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_3017_48613'
        x='8'
        y='11'
        width='32'
        height='32'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
        <feBlend
          mode='overlay'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3017_48613'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_3017_48613'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_3017_48613'
        x1='24'
        y1='48'
        x2='24'
        y2='0'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='white' stop-opacity='0.2' />
        <stop offset='1' stop-color='white' />
      </linearGradient>
    </defs>
  </svg>
)